import { Route, Routes } from 'react-router-dom';
import * as PATHS from './CONSTANTS'
import CustomerSignup from '../pages/auth/registration'
import DashBoard from '../pages/dashboard';
import CustomerLogIn from '../pages/auth/login'
import Verification from '../pages/verification'
import Positions from '../pages/positions';
import ContractResources from '../pages/contractresources';
import Settings from '../pages/settings';
import AppliedCandidates from '../pages/positionDetails';
import CompanySettings from '../pages/companySettings';
import CreatePositions from '../pages/createPositions';
import ForgotPassword from '../pages/auth/forgotPassword';
import Preview from '../pages/preview/index'
import ResetPassword from '../pages/auth/resetPassword';
import CustomerRating from '../pages/customerRating';
import TimeSheet from '../pages/timeSheet';
import TimeSheetHistory from '../pages/timeSheetHistory';
import MailTimesheet from '../pages/timesheetMailRedirection'


const RouterConfig = () => {
    return (
        <Routes>
            
            <Route path={PATHS.CUSTOMERSIGNUP} element={< CustomerSignup/>} />
            <Route path={PATHS.CUSTOMERSIGNUP1} element={< CustomerSignup/>} />
            <Route path={PATHS.RESETPASSWORD} element={<ResetPassword/>} />
            <Route path={PATHS.FORGOTPASSWORD} element={<ForgotPassword/>} />
            <Route path={PATHS.DASHBOARD} element={< DashBoard/>} />
            <Route path={PATHS.LOGIN} element={<CustomerLogIn/>} />
            <Route path={PATHS.VERIFICATION} element={<Verification />} />
            <Route path={PATHS.POSITIONS} element={<Positions />} />
            <Route path={PATHS.CONTRACTRESOURCES} element={<ContractResources/>} />
            <Route path={PATHS.SETTINGS} element={<Settings/>} />
            <Route path={PATHS.APPLIEDCANDIDATES} element={<AppliedCandidates />} />
            <Route path={PATHS.COMPANYSETTINGS} element={<CompanySettings/>} />
            <Route path={PATHS.CREATEPOSITIONS} element={<CreatePositions/>} />
            <Route path={PATHS.PREVIEW} element={<Preview/>} />
            <Route path={PATHS.CUSTOMERRATINGS} element={<CustomerRating/>} />
            <Route path={PATHS.TIMESHEET} element={<TimeSheet/>}/>
            <Route path={PATHS.TIMESHEETHISTORY} element={<TimeSheetHistory/>}/>
            <Route path={PATHS.MAILTIMESHEET} element={<MailTimesheet/>}/>
        </Routes>
    )
}

export default RouterConfig;